/* eslint-disable react/no-unescaped-entities */
import React from 'react'

export default function Noresult() {
    return (
        <div className='h-full'>
            <div className="flex justify-center items-center h-full p-[46px]">
                <div className="flex flex-col text-center h-full">
                    <img src="/assets/images/empty.png" alt="" className="pb-6 h-[90%]"/>
                    <p className=" text-lg font-normal text-black">
                        We couldn't find what you searched for. <br /> Please try a
                        different search or try again
                    </p>
                </div>
            </div>
        </div>
    )
}
